import React, { Fragment } from 'react'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import HomePackage from './HomePackage';

export default function PackageList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Test Packages" parent="Home" title="List of Test Packages" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <HomePackage />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
